import { TFunction } from "i18next";
import { TestContext } from "yup";

const MIN_YEAR = 1900;
const MIN_AGE = 18;

type DOBErrorValues = { fields?: string };

export function validateDOB(dobDay: string, dobMonth: string, dobYear: string, t: TFunction, context: TestContext) {
  const createError = (messageKey: string, values?: DOBErrorValues) => {
    return context.createError({
      path: "dobCombined",
      message: t(messageKey, values),
    });
  };

  if (!dobDay && !dobMonth && !dobYear) {
    return createError("personalDetails.error.dobRequired");
  }

  const missingFields = [
    { value: dobDay, name: "day" },
    { value: dobMonth, name: "month" },
    { value: dobYear, name: "year" },
  ]
    .filter((field) => !field.value)
    .map((field) => field.name);

  if (missingFields.length > 0) {
    return createError("personalDetails.error.dobMissingFields", {
      fields: missingFields.join(" and "),
    });
  }

  const day = parseInt(dobDay, 10);
  const month = parseInt(dobMonth, 10);
  const year = parseInt(dobYear, 10);

  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return createError("personalDetails.error.dobInvalidDate");
  }

  if (day < 1 || day > 31) {
    return createError("personalDetails.error.dobDayInvalid");
  }

  if (month < 1 || month > 12) {
    return createError("personalDetails.error.dobMonthInvalid");
  }

  if (year < MIN_YEAR) {
    return createError("personalDetails.error.dobYearInvalid");
  }

  const date = new Date(year, month - 1, day);
  const isValidDate = date.getDate() === day && date.getMonth() === month - 1 && date.getFullYear() === year;

  if (!isValidDate) {
    return createError("personalDetails.error.dobInvalidDate");
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (date > today) {
    return createError("personalDetails.error.dobInFuture");
  }

  const minAgeDate = new Date(today.getFullYear() - MIN_AGE, today.getMonth(), today.getDate());
  if (date > minAgeDate) {
    return createError("personalDetails.error.dobMinAge");
  }

  return true;
}
